<template>
  <div
    class="modal fade"
    id="importUsersDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            ×
          </button>

          <h4 class="modal-title">
            <b>Import Users</b>
          </h4>
        </div>
        <div class="modal-body" v-if="importStep === 1">
          <template v-if="!feature.isAudiTarget">
            <div class="form-group">
              <label
                for="importUsersUserTypeSelect"
                class="col-md-2 control-label"
                >User Type</label
              >
              <div class="col-md-10">
                <!-- re-render on nested properties workarround -->
                <select2
                  id="importUsersUserTypeSelect"
                  class="form-control"
                  :afterChange="
                    (u) => {
                      selectedRoleID = u;
                    }
                  "
                  :dataTransformer="(data) => Number(data[0].id)"
                  :key="importUsersDialogData.UserTypeId"
                  v-model="importUsersDialogData.UserTypeId"
                  :placeholder="'Please select an user type...'"
                  :allowClear="true"
                >
                  <option
                    v-for="type in roleData.filter(
                      (r) => r.RoleTypeName !== 'MSM_Administrator'
                    )"
                    :key="type.RoleTypeGuid"
                    :value="type.UserTypeId"
                    :disabled="type.UserTypeId != 4"
                  >
                    {{ type.RoleTypeDisplayName }}
                  </option>
                </select2>
              </div>
            </div>
            <div class="form-group" v-show="selectedRoleID == 4">
              <label
                for="importUsersClientSelect"
                class="col-md-2 control-label"
                >Client *</label
              >
              <div class="col-md-10">
                <select2
                  id="importUsersClientSelect"
                  class="form-control"
                  :placeholder="'Please select a client...'"
                  :allowClear="true"
                  :key="importUsersDialogData.UserTypeId"
                  v-model="importUsersDialogData.ClientId"
                >
                  <option
                    v-for="client in clientList"
                    :key="client.ClientId"
                    :value="client.ClientId"
                  >
                    {{ client.ClientName }}
                  </option>
                </select2>
              </div>
            </div>
            <div class="form-group" v-show="selectedRoleID == 2">
              <label
                for="importUsersAgencySelect"
                class="col-md-2 control-label"
                >Partner</label
              >
              <div class="col-md-10">
                <select2
                  id="importUsersAgencySelect"
                  class="form-control"
                  :placeholder="'Please select a partner...'"
                  :allowClear="true"
                  :key="importUsersDialogData.UserTypeId"
                  v-model="importUsersDialogData.AgencyId"
                >
                  <option
                    v-for="agency in agencyList"
                    :key="agency.AgencyGuid"
                    :value="agency.AgencyId"
                  >
                    {{ agency.AgencyName }}
                  </option>
                </select2>
              </div>
            </div>
          </template>

          <form>
            <div class="form-group" style="padding-top: 20px">
              <p>
                <b>Bitte wählen Sie eine Option aus</b>
              </p>

              <!-- Tabs for selecting the import type -->
              <ul class="nav nav-tabs nav-import" style="margin-bottom: 15px">
                <li class="active">
                  <a
                    href="#importUsersTextImport"
                    data-toggle="tab"
                    @click="importUsersDialogData.selectedOption = 'text'"
                    >Text</a
                  >
                </li>
                <li v-if="globals.isAccessAllowed('LoopOp_Upload_Create')">
                  <a
                    href="#importUsersFileImport"
                    data-toggle="tab"
                    @click="importUsersDialogData.selectedOption = 'file'"
                    >File</a
                  >
                </li>
              </ul>
              <div id="importUsersTabContent" class="tab-content">
                <div class="tab-pane fade active in" id="importUsersTextImport">
                  <!-- Textarea for text-import -->
                  <label
                    for="importUsersImportTextArea"
                    class="col-md-1 control-label"
                    >Text-Import</label
                  >
                  <div class="col-md-11">
                    <textarea
                      class="form-control"
                      rows="7"
                      id="importUsersImportTextArea"
                      v-model="importUsersDialogData.selectedText"
                    ></textarea>
                  </div>
                </div>

                <div class="tab-pane fade" id="importUsersFileImport">
                  <!-- File upload for file-import -->
                  <label
                    for="importUsersImportFileInput"
                    class="col-md-1 control-label"
                    >File-Import</label
                  >
                  <div class="col-md-11">
                    <input
                      id="importUsersImportFileInput"
                      class="form-control"
                      type="file"
                      accept=".xlsx"
                      @change="onImportFileChange"
                    />
                    <div class="input-group">
                      <label
                        v-if="!importUsersDialogData.selectedFile.name"
                        style="padding-top: 16px"
                        >Bitte wählen Sie eine Datei...</label
                      >
                      <label v-else style="padding-top: 16px">{{
                        importUsersDialogData.selectedFile.name
                      }}</label>
                      <span class="input-group-btn input-group-sm">
                        <button type="button" class="btn btn-fab btn-fab-mini">
                          <i class="material-icons">attach_file</i>
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <button
                    type="button"
                    class="btn"
                    style="margin-top: 30px"
                    @click="
                      importUsersDialogData.trimImportData =
                        !importUsersDialogData.trimImportData
                    "
                  >
                    <i
                      v-if="importUsersDialogData.trimImportData"
                      class="material-icons md-24"
                      >check_box</i
                    >
                    <i v-else class="material-icons md-24"
                      >check_box_outline_blank</i
                    >
                    Trim import data
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-body" v-if="importStep === 2">
          <p>
            An folgenden Positionen der hochgeladenen Daten, sind Fehler
            aufgetreten:
          </p>
        </div>

        <div class="modal-body" v-if="importStep === 3">
          <p>
            Eine Liste der generierten Passwörter steht jetzt zum Download
            bereit
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised btn-default"
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            v-if="importStep === 1"
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="uploadImportData()"
          >
            Upload
          </button>
          <button
            v-if="importStep === 3"
            type="button"
            class="btn btn-raised dialog-btn-primary"
            @click="downloadUserList()"
          >
            Download
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "./Tools/Select2";

export default {
  name: "ImportUsersModal",
  components: { Select2 },
  mounted() {
    $("#importUsersDialog").on("hidden.bs.modal", () => {
      this.$emit("dialogClosed");
    });

    $("#importUsersImportFileInput").click((e) => {
      $(e.target).val("");
      this.importUsersDialogData.selectedFile = {};
      this.$forceUpdate();
    });
  },
  methods: {
    openImportUsersDialog() {
      let selOption = this.importUsersDialogData.selectedOption;
      this.importUsersDialogData = {
        selectedOption: selOption,
        selectedText: "",
        selectedFile: {},
        serverResponse: {},
        trimImportData: false,
      };

      if (this.feature.isAudiTarget && this.clientList[0]) {
        this.importUsersDialogData.UserTypeId = 4;
        this.importUsersDialogData.ClientId = this.clientList[0].ClientId;
      }

      $("#importUsersImportFileInput").val("");
      this.importStep = 1; //TODO:
      $("#importUsersDialog").modal("show");
    },

    closeImportUsersDialog() {
      $("#importUsersDialog").modal("hide");
    },

    downloadUserList() {
      // TODO:
      if (
        this.importUsersDialogData.serverResponse &&
        this.importUsersDialogData.serverResponse[0] &&
        this.importUsersDialogData.serverResponse[0].DownloadId
      ) {
        this.globals.downloadFile(
          this.importUsersDialogData.serverResponse[0].DownloadId
        );
        this.closeImportUsersDialog();
      } else console.error("Missing downloadId in downloadUserList()");
    },

    uploadImportData() {
      if (
        this.importUsersDialogData.UserTypeId == 4 &&
        !this.importUsersDialogData.ClientId
      ) {
        this.globals.showErrorSnackbar("Please select a client");
        console.error("Missing client selection for user export");
        return;
      }

      if (this.importUsersDialogData.selectedOption === "text") {
        if (this.importUsersDialogData.selectedText === "") {
          this.globals.showErrorSnackbar("Please insert import data");
          console.error(
            "Error: No import text available in uploadImportData()"
          );
          return;
        }

        // Escape all " characters
        let importText = this.importUsersDialogData.selectedText.replace(
          /"/g,
          '\\"'
        );

        // Build import JSON
        let importString = '{"data":"';
        importString += importText + '"';
        importString += ',"trim":' + this.importUsersDialogData.trimImportData;
        importString += "}";

        let url = "api/SecurityUsers/Import";
        if (this.importUsersDialogData.UserTypeId) {
          url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
          if (
            this.importUsersDialogData.UserTypeId == 4 &&
            this.importUsersDialogData.ClientId
          )
            url += "&clientId=" + this.importUsersDialogData.ClientId;
          if (
            this.importUsersDialogData.UserTypeId == 2 &&
            this.importUsersDialogData.AgencyId
          )
            url += "&agencyId=" + this.importUsersDialogData.AgencyId;
        }

        $.ajax({
          method: "POST",
          url: url,
          data: importString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          timeout: 600000,
          success: (data) => {
            // this.importUsersDialogData.serverResponse = data;
            // this.importStep = 2;
            this.getCurrentImportData();
          },
          error: () => {
            console.error("Error on POST in uploadImportData()");
            this.globals.showErrorSnackbar("User import failed");
          },
          complete: () => {
            this.importUsersDialogData.selectedText = "";
            this.importUsersDialogData.selectedFile = {};
            $("#importUsersImportFileInput").val("");
            this.$emit("importComplete");
          },
        });
      } else if (this.importUsersDialogData.selectedOption === "file") {
        if (_.isEmpty(this.importUsersDialogData.selectedFile)) {
          console.error(
            "Error: No import file available in uploadImportData()"
          );
          this.globals.showErrorSnackbar("Please select an import file");
          return;
        }

        let importString =
          '{"file":"' + this.importUsersDialogData.selectedFile.file + '"';
        importString +=
          ',"trim":' + this.importUsersDialogData.trimImportData + "}";

        let url = "api/SecurityUsers/Import";
        if (this.importUsersDialogData.UserTypeId) {
          url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
          if (
            this.importUsersDialogData.UserTypeId == 4 &&
            this.importUsersDialogData.ClientId
          )
            url += "&clientId=" + this.importUsersDialogData.ClientId;
          if (
            this.importUsersDialogData.UserTypeId == 2 &&
            this.importUsersDialogData.AgencyId
          )
            url += "&agencyId=" + this.importUsersDialogData.AgencyId;
        }

        $.ajax({
          method: "POST",
          url: url,
          data: importString,
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          timeout: 600000,
          success: (data) => {
            // this.importUsersDialogData.serverResponse = data;
            // this.importStep = 2;
            this.getCurrentImportData();
          },
          error: (data) => {
            console.error("Error on POST in uploadImportData()");
            this.globals.showErrorSnackbar("User import failed");
          },
          complete: () => {
            this.importUsersDialogData.selectedText = "";
            this.importUsersDialogData.selectedFile = {};
            $("#importUsersImportFileInput").val("");
          },
        });
      }
    },

    getCurrentImportData() {
      let url = `api/SecurityUsers/Import?page_size=0&filter={"Errors":false}`;

      $.ajax({
        method: "GET",
        url: url,
        success: (data) => {
          if (data && data[0]) {
            if (data[0].Error_Counter) this.importStep = 2;
            else this.saveImportData();
          }
        },
        error: () => {
          console.error("Error on GET in getCurrentImportData()");
          this.globals.showErrorSnackbar("Import data access failed");
        },
      });
    },

    saveImportData() {
      let dataString = '{"save":true}';

      // the save action also needs to know which usertype and id to use
      // because we again check for errors
      let url = "api/SecurityUsers/Import";
      if (this.importUsersDialogData.UserTypeId) {
        url += "?userTypeId=" + this.importUsersDialogData.UserTypeId;
        if (
          this.importUsersDialogData.UserTypeId == 4 &&
          this.importUsersDialogData.ClientId
        )
          url += "&clientId=" + this.importUsersDialogData.ClientId;
        if (
          this.importUsersDialogData.UserTypeId == 2 &&
          this.importUsersDialogData.AgencyId
        )
          url += "&agencyId=" + this.importUsersDialogData.AgencyId;
      }

      $.ajax({
        method: "POST",
        url: url,
        data: dataString,
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.globals.showSuccessSnackbar("User import successful");

          if (data && data[0] && data[0].DownloadId) {
            this.importUsersDialogData.serverResponse = data;
            this.importStep = 3;
          } else {
            this.closeImportUsersDialog();
          }
          //TODO: Download password list
        },
        error: () => {
          console.error("Error on POST in saveImportData()");
          this.globals.showErrorSnackbar("User import failed");
        },
      });
    },

    onImportFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length || !files[0].name) {
        this.importUsersDialogData.selectedFile = {};
        return;
      }
      let fileObject = files[0];

      let uploadSuccess = (data) => {
        if (!data || !data[0]) return;

        if (this.importUsersDialogData.selectedFile) {
          this.importUsersDialogData.selectedFile.file = data[0].DownloadId;
          this.importUsersDialogData.selectedFile.name = fileObject.name;
        } else this.importUsersDialogData.selectedFile = data;

        this.$forceUpdate();
      };
      this.globals.uploadFile(fileObject, false, uploadSuccess);
      e.target.value = null;
    },
  },
  watch: {
    showDialog(newValue) {
      if (newValue === true) this.openImportUsersDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  props: ["showDialog", "roleData", "clientList", "agencyList"],
  data() {
    // Global data inside the component is stored here
    return {
      selectedRoleID: -1,
      importUsersDialogData: {
        selectedOption: "text",
        selectedText: "",
        selectedFile: {},
        serverResponse: {},
        trimImportData: false,
      },
      importStep: 1,
      lang: {},
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-import {
  background-color: var(--color-primary);
}
.nav-import > li {
  text-align: center;
  float: none;
  display: inline-block;
}
.nav-import > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}

#importUsersImportFileInput {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// ImportUsersModal.vue?59bb6937